import { optionsForMarket, type SingleQuestionDefinition } from "@ferrivia/api-contract";
import { useMarket } from "@ferrivia/i18n";
import { ToggleChip } from "@ferrivia/ui";
import s from "./ChoiceGroup.module.css";
import fs from "./MultiChoiceQuestion.module.css";

export interface MultiChoiceQuestionProps {
  question: SingleQuestionDefinition;
  /** The fieldset's legend -- visually the question label, replacing the
      `<h2>` `QuestionBlock` renders for every other kind (see its own
      comment on why). */
  legend: string;
  value: readonly string[];
  onChange: (selected: string[]) => void;
  optionLabelFor: (optionId: string) => string;
}

export function MultiChoiceQuestion({ question, legend, value, onChange, optionLabelFor }: MultiChoiceQuestionProps) {
  const options = optionsForMarket(question.options ?? [], useMarket());

  function toggle(optionId: string) {
    onChange(value.includes(optionId) ? value.filter((id) => id !== optionId) : [...value, optionId]);
  }

  return (
    <fieldset className={fs.fieldset}>
      <legend className={fs.legend}>{legend}</legend>
      <div className={s.chips}>
        {options.map((option) => (
          <ToggleChip key={option.id} className={s.chip} checked={value.includes(option.id)} onChange={() => toggle(option.id)}>
            {optionLabelFor(option.id)}
          </ToggleChip>
        ))}
      </div>
    </fieldset>
  );
}
